import React, { useEffect, useRef } from "react";


/* 
    KUCOIN:BTCUSDT    
    KUCOIN:ETHUSDT
    KUCOIN:TRXUSDT
    KUCOIN:1INCHUSDT
    KUCOIN:BNBUSDT
    COINBASE:USDTUSD
*/

const OtcMiniChart = ({symbol}) => {

    const ref = useRef()

    const dateRange = symbol === "COINBASE:USDTUSD" ? "1M" : "1D"

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-mini-symbol-overview.js'
        script.async = true;
        script.innerHTML = JSON.stringify({
            "symbol": `${symbol}`,
            "width": "100%",
            "height": "100%",
            "locale": "en",
            "dateRange": `${dateRange}`,
            "colorTheme": "light",
            "trendLineColor": "rgba(41, 98, 255, 1)",
            "underLineColor": "rgba(41, 98, 255, 0.3)",
            "underLineBottomColor": "rgba(41, 98, 255, 0)",
            "isTransparent": true,
            "autosize": true,
            "largeChartUrl": ""
        })
        ref.current.innerHTML = ""
        ref.current.appendChild(script);
    }, [symbol])


    return (
        <div className="tradingview-widget-container" ref={ref}>
            <div className="tradingview-widget-container__widget"/>
        </div>
    );
}

export default OtcMiniChart;